
export const menuItems = [
	{name: "Inicio", to: "/paquetes", iconClassName: "menu-icon--home", titleMobile:"Inicio"},
	{name: "Mis retiros", to: "/mis-retiros", iconClassName: "menu-icon--retiro", titleMobile: "Retiros"},
	{name: "Oficinas", to: "/oficinas", iconClassName: "menu-icon--office", titleMobile: "Oficinas"},
	{name: "Reclamos y consultas", to: "/reclamos-y-consultas", iconClassName: "menu-icon--claim", titleMobile: "Reclamos"},
	{name: "Preguntas frecuentes", to: "/preguntas", iconClassName: "menu-icon--question", titleMobile: "Preguntas"},
];